import {Icon} from '@iconify/react';

import type {SVGProps} from 'react';

export function SquareAltArrowRightLinearIcon(props: SVGProps<SVGSVGElement>) {
  return <Icon icon="solar:square-alt-arrow-right-linear" {...(props as object)} />;
}
